import { ActionsChoiceOption } from '../../Choice/ActionsChoiceOption';
import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
export class ActionsMultipleChoice extends ActionRegistryCategory {
    label = 'Common';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_option = new ActionsChoiceOption(this);
}
